export function numberLocalization(numb: number | undefined | null): string | null {
  if (numb === null || numb === undefined) {
    return null;
  }
  return numb.toLocaleString('en');
}
